"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _reactRouterDom = require("react-router-dom");

var _classnames = _interopRequireDefault(require("classnames"));

var _beNovativeKit = _interopRequireDefault(require("@bit/be-novative.kit.spinner"));

var _Button = require("./Button.propTypes");

var _ButtonModule = _interopRequireDefault(require("./Button.module.scss"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

Button.propTypes = {
  fillParent: _propTypes.default.bool,
  size: _propTypes.default.oneOf(_Button.sizes),
  loading: _propTypes.default.bool,
  type: _propTypes.default.oneOf(['button', 'submit']),
  uppercase: _propTypes.default.bool,
  variant: _propTypes.default.oneOf(_Button.variants),
  onClick: _propTypes.default.func,
  to: _propTypes.default.string,
  textAlign: _propTypes.default.oneOf(_Button.alignments),
  hideLabel: _propTypes.default.bool
};
Button.defaultProps = {
  fillParent: false,
  onClick: function onClick() {},
  size: 'normal',
  textAlign: 'center',
  type: 'button',
  uppercase: false
};

function Button(_ref) {
  var _cn;

  var children = _ref.children,
      fillParent = _ref.fillParent,
      size = _ref.size,
      type = _ref.type,
      uppercase = _ref.uppercase,
      variant = _ref.variant,
      className = _ref.className,
      onClick = _ref.onClick,
      to = _ref.to,
      loading = _ref.loading,
      disabled = _ref.disabled,
      hideLabel = _ref.hideLabel,
      textAlign = _ref.textAlign,
      rest = _objectWithoutProperties(_ref, ["children", "fillParent", "size", "type", "uppercase", "variant", "className", "onClick", "to", "loading", "disabled", "hideLabel", "textAlign"]);

  var classes = (0, _classnames.default)(className, _ButtonModule.default.Button, _ButtonModule.default[size], (_cn = {}, _defineProperty(_cn, _ButtonModule.default[variant], !!variant), _defineProperty(_cn, _ButtonModule.default.fill, fillParent), _defineProperty(_cn, _ButtonModule.default.uppercase, uppercase), _defineProperty(_cn, _ButtonModule.default.submitting, loading), _defineProperty(_cn, _ButtonModule.default['hide-label'], hideLabel), _cn));
  var isLink = !!to;
  var isLocked = disabled || loading;

  var buttonProps = _objectSpread({}, rest, {
    className: classes,
    disabled: isLocked,
    onClick: isLocked ? undefined : onClick,
    to: isLocked ? undefined : to
  });

  var justifyContent;

  switch (textAlign) {
    case 'left':
      justifyContent = 'flex-start';
      break;

    case 'center':
      justifyContent = 'center';
      break;

    case 'right':
      justifyContent = 'flex-end';
      break;

    default:
  }

  return isLink ? /*#__PURE__*/_react.default.createElement(_reactRouterDom.Link, buttonProps, /*#__PURE__*/_react.default.createElement("span", {
    className: _ButtonModule.default.Inner,
    style: {
      justifyContent: justifyContent
    }
  }, children)) : /*#__PURE__*/_react.default.createElement("button", _extends({}, buttonProps, {
    type: type
  }), /*#__PURE__*/_react.default.createElement("span", {
    className: _ButtonModule.default.Inner,
    style: {
      justifyContent: justifyContent
    }
  }, children), loading && /*#__PURE__*/_react.default.createElement("span", {
    className: _ButtonModule.default.Spinner
  }, /*#__PURE__*/_react.default.createElement(_beNovativeKit.default, {
    type: "bubble",
    size: "medium",
    "data-test": "spinner"
  })));
}

var _default = Button;
exports.default = _default;

//# sourceMappingURL=Button.js.map